<template>
  <div>
    <v-card outlined :loading='loading' :height='height'>
      <v-toolbar :height="mini ? '30' : '36'" :color='color' :dark='dark' flat v-if='!hideToolbar'>
        <v-icon
          :left='title ? true : false'
          v-if='titleIcon'
          :color='titleIconColor'
        >
          {{ titleIcon }}
        </v-icon>
        <span :class='titleClass' style='line-height: 110%;'>{{ title }}</span>
        <slot name='appendTitle'></slot>
        <v-spacer></v-spacer>
        <slot name='middle_column'></slot>
        <v-spacer></v-spacer>
        <slot name='prependToolbarButtons'></slot>
        <v-btn v-if='showHelp' icon small @click='showHelpDialog = true'>
          <v-icon color='grey lighten-1'>
            mdi-help-circle-outline
          </v-icon>
        </v-btn>
        <v-btn v-if='showDownloadCSV' small icon @click="$emit('downloadCSV')">
          <v-tooltip top>
            <template v-slot:activator='{ on }'>
              <v-icon color='grey lighten-1' v-on='on'>
                mdi-file-table
              </v-icon>
            </template>
            <span>Download as Spreadsheet</span>
          </v-tooltip>
        </v-btn>
        <wc-toolbar-search
          v-if='showSearch'
          v-bind:value="value"
          v-on:input="$emit('input', $event)"
        ></wc-toolbar-search>
        <slot name='toolbarButtons'></slot>
        <v-btn v-if='showArchived' small icon @click="$emit('toggleShowArchived')">
          <v-icon :color="showArchivedStatus ? 'error': 'grey lighten-1'">
            mdi-archive
          </v-icon>
        </v-btn>
        <v-btn v-if='showEdit' small icon @click="$emit('edit')">
          <v-icon color='grey lighten-1'>
            mdi-pencil-outline
          </v-icon>
        </v-btn>
        <v-btn v-if='showAdd' :icon='!on_phone' :class='on_phone ? "ml-2" : ""' small @click="$emit('add')" :depressed='on_phone' :color="on_phone ? 'primary' : ''" >
          <v-icon :color="!on_phone ? 'grey lighten-1' : ''" :left='on_phone' :small='on_phone'>
            mdi-plus
          </v-icon>
          <span v-if='on_phone'>ADD</span>
        </v-btn>
        <slot name='appendToolbarButtons'></slot>
      </v-toolbar>
      <v-divider v-if='!hideToolbar'></v-divider>
      <slot></slot>
      <v-card-actions v-if='actions'>
        <slot name='left-actions'>
          <v-btn v-if='cancelText' text small color='error' @click="$emit('cancel')">{{ cancelText }}</v-btn>
          <v-btn v-if='saveText' text small color='info' @click="$emit('save')">{{ saveText }}</v-btn>
        </slot>
        <slot name='right-actions'></slot>
      </v-card-actions>
    </v-card>

    <wc-dialog
      :showDialog='showHelpDialog'
      title='Help'
      icon='mdi-help-circle-outline'
      :width='helpWidth'
      hideCancel
      saveText='OK'
      @save='showHelpDialog = false'
    >
      <span v-html='helpText'></span>
    </wc-dialog>
  </div>
</template>

<script>
export default {
  name: 'wc-data-box',
  props: {
    value: {
      required: false
    },
    title: {
      required: false
    },
    color: {
      required: false,
      default: 'grey lighten-4'
    },
    dark: {
      required: false,
      type: Boolean,
      default: false
    },
    hideToolbar: {
      required: false,
      type: Boolean,
      default: false
    },
    loading: {
      required: false,
      type: Boolean,
      default: false
    },
    titleIcon: {
      required: false
    },
    titleIconColor: {
      required: false,
      default: 'info'
    },
    actions: {
      required: false,
      type: Boolean
    },
    cancelText: {
      required: false
    },
    saveText: {
      required: false
    },
    showAdd: {
      required: false,
      type: Boolean,
      default: false
    },
    showEdit: {
      required: false,
      type: Boolean,
      default: false
    },
    showSearch: {
      required: false,
      type: Boolean,
      default: false
    },
    showHelp: {
      required: false,
      type: Boolean,
      default: false
    },
    showArchived: {
      // This prop will simply add the archive button
      required: false,
      type: Boolean,
      default: false
    },
    showDownloadCSV: {
      // Specifically for downloading a data set in comman seperated values (CSV -- spreadsheet format)
      required: false,
      type: Boolean,
      default: false
    },
    showArchivedStatus: {
      // This prop will let this component know whether we are SHOWING (status = true) archived or NOT (status = false)
      required: false,
      type: Boolean,
      default: false
    },
    helpText: {
      required: false
    },
    helpWidth: {
      required: false,
      type: [String, Number],
      default: "350"
    },
    mini: {
      // shortens the toolbar, makes the title smaller
      required: false,
      type: Boolean,
      default: false
    },
    height: {
      required: false,
      type: String
    }
  },
  data: () => ({
    showHelpDialog: false
  }),
  computed: {
    titleClass () {
      let ret = 'text-uppercase '
      if (this.dark) {
        ret += 'white--text '
      } else {
        ret += 'grey--text text--darken-3 '
      }
      return ret
    },
    on_phone () {
      return this.$vuetify.breakpoint.smAndDown
    }
  }
}
</script>
